import { ThumbDown, ThumbUp } from '@mui/icons-material';
import { Box, Grid, Paper, Stack, SvgIcon, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const getColor = (value, summary_colors) => {
  const { colors } = summary_colors || {}
  const rank = colors && colors.length > 0 ? colors?.find(d => d.rank === value) : null
  return rank ? rank?.color : '#fff';
};

const metrics = [
  { key: 'growth_rank', label: 'Growth' },
  { key: 'profitability_rank', label: 'Profitability' },
  { key: 'size_rank', label: 'Size' },
  { key: 'dilution_rank', label: 'Dilution Risk' },
  { key: 'bs_rank', label: 'Balance Sheet' },
  { key: 'momentum_rank', label: 'Momentum' },
  { key: 'funds_rank', label: 'Funds Popularity' },
  { key: 'insider_rank', label: 'Insider Trading' }
];

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgb(10, 25, 41)' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  // height: useMediaQuery((theme) => theme.breakpoints.down('sm')) ? '' : '100%',
  boxShadow: theme.palette.mode === 'dark' ? 0 : '0 0.5px 1px rgb(255 255 255 / 20%), 0 2px 3px rgb(255 255 255 / 10%)',
  border: theme.palette.mode === 'dark' ? '1px solid rgb(19, 47, 76)' : '1px solid #eae9ee',
  borderRadius: '7px',
  marginBottom: '5px',
  '& .Item-Head': {
    background: '#f2f2f2',
    borderBottom: '1px solid #eae9ee',
    padding: '0 8px',
    borderRadius: '6px 6px 0 0',
    '& .option-title': {
      fontWeight: 500,
      color: '#333',
      fontSize: '.875rem',
    }
  },
  '& .Item-Body': {
    padding: theme.spacing(0, 1),
    color: '#13113c'
  }
}));

const SummaryRanks = ({ summary_ranks, summary_colors }) => {
  let data = summary_ranks && summary_ranks.length > 0 ? summary_ranks.find(d => d.halfCode === "SUMMARY_RANKS") : null;
  data = data && data?.v ? JSON.parse(data?.v)[0] : [];

  return (
    <>
      {data ?
        <Grid size={{ xs: 12, sm: 12 }}>
          <Item className="crisischart">
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }} className="Item-Head">
              <Typography component="h3" className="option-title">
                {/* {data.ticker} Summary Ranks */}
                The Good, Bad and Ugly
              </Typography>
            </Box>
            <Box sx={{ width: '100%', my: 0 }}>
              <Box component="div" className="Item-Body">
                <Box component="div" sx={{ pt: 0.5, pb: 0.5 }}>
                  {metrics.map((metric, i) => {
                    const value = data[metric.key];
                    const absValue = Math.abs(value) > 2 ? 2 : Math.abs(value);
                    const color = getColor(value, summary_colors);

                    return (
                      <Box key={metric.key} className="quality s-card shadow-none pt-3 pb-0" component="div" sx={{ mb: .3 }}>
                        <Stack spacing={1.2} direction="row" alignItems="center" justifyContent="space-between">
                          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {metric.label}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {Array.from({ length: absValue || 1 }).map((_, idx) => (
                              value > 0 ? (
                                <ThumbUp key={idx} sx={{ color }} />
                              ) : (value == 0 ?
                                // <SvgIcon key={idx}>
                                //   <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ThumbUpIcon">
                                //     <rect x="3" y="9" width="18" height="4" style={{ fill: '#999', strokeWidth: 0, }}></rect>
                                //   </svg>
                                // </SvgIcon> :
                                <>
                                  <ThumbUp key={idx} sx={{ color }} />
                                  <ThumbDown key={idx} sx={{ color }} />
                                </>
                                :
                                <ThumbDown key={idx} sx={{ color }} />
                              )
                            ))}
                          </Box>
                        </Stack>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Item>
        </Grid> : null}
    </>
  );
};

export default React.memo(SummaryRanks);
